import React, { useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import {
  backBtnImg,
  CHANGE_LANGUAGE,
  CHANGE_LANGUAGE_DEFAULT,
  defaultRestaurantImage,
  LANGUAGE_ELLIPSE,
  PROFILE_RED,
  PROFILE_WHITE,
} from '../../../paths/defaultImage';
import { menuFilterAction } from '../../../redux/menuFilter/action';
import { UPDATE_FILTERS } from '../../../redux/menuFilter/types';
import { fetchUser } from '../../../redux/userDetails/userDetailsActions';
import { DINEIN_TYPE } from '../../../webStorage/keys/sessionKeys';
import { setUserToken } from '../../../webStorage/localStorage';
import { getOrderType } from '../../../webStorage/manageOrderType';
import { getSessionItem, setSessionItem } from '../../../webStorage/sessionStorage';
import BellIcon from '../../common/bellIcon';
import StarRating from '../../common/starRating';
import { LANGUAGE_ENUMS } from '../../../functions/getCountryCode';
import useMountTransition from '../../../functions/customHooks/useMountTransition';
import LazyImage from '../../common/lazyLoad';
function ProfileHeader(props) {
  const dispatch = useDispatch();
  const history = useHistory();
  const orderType = getOrderType();
  const { mall } = useParams();
  const restarantSettingFromRedux = useSelector((state) => state.restSetting?.Setting);
  const isBellEnabled = restarantSettingFromRedux?.settings?.global?.service_bell_enable;
  const resCover = restarantSettingFromRedux?.menu_cover_img;
  const scanThroughQr = getSessionItem('scanThroughQr');
  const showBackBtn = !JSON.parse(scanThroughQr) || false;
  const selectedLanguage = getSessionItem('i18nextLng') || 'en';
  const isSelectedLanguageEng = selectedLanguage === LANGUAGE_ENUMS['en'].languageCode;
  const [showTooltip, setShowTooltip] = useState(false);
  const hasTransitionedIn = useMountTransition(showTooltip, 500);

  useEffect(() => {
    if (getSessionItem('showLanguageTooltip')) return;
    setTimeout(() => setShowTooltip(true), 1500);
    setTimeout(() => {
      setShowTooltip(false);
      setSessionItem('showLanguageTooltip', true);
    }, 6500);
  }, []);

  const [cookies] = useCookies();
  if (cookies.token && cookies.token !== 'undefined') {
    if (!localStorage.getItem('auth_token') || localStorage.getItem('auth_token') === 'undefined') {
      setUserToken(cookies.token);
    }
  }

  const goToNext = () => {
    dispatch(menuFilterAction([], UPDATE_FILTERS));
    history.push('/home');
  };
  const userDetailsPatched = () => {
    dispatch(fetchUser());
  };
  useEffect(() => {
    userDetailsPatched();
  }, [props.fetchUser]);
  const onError = (elem) => (elem.target.src = defaultRestaurantImage);

  const LanguageChangeComp = (
    <div
      className={`menu-header__language ${isSelectedLanguageEng ? '' : 'not-eng'}`}
      onClick={() => props.setShowChangeLanguage(true)}>
      <LazyImage
        className={`menu-header__language-img ${isSelectedLanguageEng ? '' : 'not-eng'}`}
        alt='language'
        src={isSelectedLanguageEng ? CHANGE_LANGUAGE_DEFAULT : CHANGE_LANGUAGE}
      />
      {isSelectedLanguageEng ? '' : LANGUAGE_ENUMS[selectedLanguage].name}
      {(showTooltip || hasTransitionedIn) && (
        <>
          <div className='arrow'></div>
          <div
            className={`tooltip__container ${hasTransitionedIn ? 'in' : ''} ${
              showTooltip ? 'visible' : ''
            }`}>
            <LazyImage
              alt='language_ellipse'
              src={LANGUAGE_ELLIPSE}
              height={28}
              width={28}></LazyImage>
            Change your language here<br></br>
            Ubah bahasa Anda di sini
          </div>
        </>
      )}
    </div>
  );

  return (
    <div
      className={`profileHeader d-flex justify-content-between ${
        !resCover ? 'no-banner flex-column' : ''
      }`}>
      {resCover && (
        <LazyImage
          src={resCover}
          onError={onError.bind(this)}
          className='bannerImage'
          alt='banner'
          width='100%'
          height='100%'
        />
      )}

      {showBackBtn && (
        <div onClick={() => goToNext()} className={resCover ? 'add-box go-back-btn' : 'px-20 pt-3'}>
          <LazyImage src={backBtnImg} alt='goBack' height={15} width={20} />
        </div>
      )}

      <div className={`d-flex gap-10px ${!resCover ? 'box-shadow p-20 pb-0' : 'menu-logo-image'}`}>
        <LazyImage
          src={props.imageUrl}
          onError={onError.bind(this)}
          className='logo'
          alt='banner'
        />
        {!resCover && (
          <div className='fs-16 fw-700 flex-1 lh-20 d-flex flex-column gap-1'>
            <div className='w-90 break-word'>{restarantSettingFromRedux?.name}</div>
            <div className='d-flex fs-14 fw-500 gap-1 lh-16 align-items-center'>
              {props.restaurantRating > 3 ? (
                <>
                  <StarRating rating={props.restaurantRating} />|{' '}
                </>
              ) : null}
              <span className='line-clamp-1'>
                {!!props.cuisine.length && `${props.cuisine.join(', ')}`}
              </span>
            </div>
          </div>
        )}
        {!resCover && LanguageChangeComp}
        {!mall && orderType == DINEIN_TYPE && isBellEnabled == 1 && !resCover && (
          <BellIcon openDrawer={props.setDrawer} />
        )}
        {scanThroughQr && !resCover && (
          <LazyImage
            className='menu-header__profile'
            src={resCover ? PROFILE_WHITE : PROFILE_RED}
            onClick={() => history.push('/profileHome')}
          />
        )}
      </div>

      <div className='d-flex align-items-center justify-content-center menu-header__profile-bell gap-2'>
        {resCover && LanguageChangeComp}
        {!mall && orderType == DINEIN_TYPE && isBellEnabled == 1 && resCover && (
          <BellIcon openDrawer={props.setDrawer} />
        )}
        {scanThroughQr && resCover && (
          <LazyImage
            className='menu-header__profile'
            src={resCover ? PROFILE_WHITE : PROFILE_RED}
            onClick={() => history.push('/profileHome')}
          />
        )}
      </div>
    </div>
  );
}

export default ProfileHeader;
